import * as t from 'io-ts';
import { authorizedTo, id, links, meta } from '../..';

const data = t.type({ title: t.string });

export const recordCodec = t.type({
  id,
  data,
  authorizedTo,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
  links,
});

export const detailCodec = t.type({
  data,
  authorizedTo,
});

export const formCodec = data;
